const steps = [
  {
    icon: 'ri-pencil-ruler-2-line',
    title: 'You Design It',
    desc: 'Share your brand assets, theme, or artwork with our team. We handle the rest, from design prep to print-ready files.',
  },
  {
    icon: 'ri-printer-line',
    title: 'We Print It',
    desc: 'Full-colour, high-resolution dye-sublimation printing directly onto the skin\'s fabric for vivid, long-lasting results.',
  },
  {
    icon: 'ri-hammer-line',
    title: 'We Set It Up',
    desc: 'Professional installation at your event venue, on time, on spec, and ready to impress from the moment guests arrive.',
  },
];

export default function HowItWorks() {
  return (
    <section className="py-20 bg-gray-50 border-t border-gray-100">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-14">
          <h2 className="text-4xl font-bold text-gray-900 mb-3">How It Works</h2>
          <p className="text-gray-500 text-base">
            Three simple steps from your idea to a showstopping custom skin.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 text-center border border-gray-100 hover:-translate-y-1 transition-transform duration-300 cursor-default"
            >
              <div className="w-16 h-16 mx-auto mb-5 bg-teal-400 rounded-2xl flex items-center justify-center">
                <i className={`${step.icon} text-3xl text-white`}></i>
              </div>
              <div className="inline-block bg-teal-50 text-teal-500 text-xs font-bold px-3 py-1 rounded-full mb-3 tracking-widest">
                STEP 0{index + 1}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
